import React from 'react';
import cn from 'classnames';
import ddt from '@wix/da-ddt';
import { extConfigFullscreen } from '../../../Editor/presets/Commission/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import Viewer from '../../Viewer';
import { Measureable } from '../../types';

import s from './Commission.scss';

const logger = ddt.createLogger('tiptapeditor');

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const CommissionViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    logger.log('CommissionViewer', {
      contentJson: JSON.stringify(contentJson),
      cookieType,
      defaultSize,
    });
    return (
      <Viewer
        presetId="commission"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfigFullscreen}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
CommissionViewer.displayName = 'CommissionViewer';

export default CommissionViewer;
